import React, {Component} from "react";
import {connect} from 'react-redux'
import FJWatermarkAction from "../../../redux/action/FJWatermark.action";
import FJWatermarkFont from "../view/FJWatermarkFont";
import FJColorContainer from "../../toolBar/view/FJColorContainer";
import FJLocalStore from "../../../store/FJLocalStore";
import {FJFontManager} from "fj-graph";
import {FJDocumentColorAction} from "../../../redux/action/FJRoot.action";

class FJWatermarkFontContainer extends Component {

  render() {

    const {
      loadingFonts,
      fontFamily,
      fontFamilyChanged,
      documentColors,
      addDocumentColor,
      deleteColor,
      color,
      textColorChanged,
    } = this.props;

    const fontList = FJFontManager.fontItems();
    const containerStyle = {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }

    return (
      <div style={containerStyle}>
        <FJWatermarkFont loadingFonts={loadingFonts}
                         fontFamily={fontFamily}
                         fontFamilyList={fontList}
                         fontFamilyChange={fontFamilyChanged} />
        <FJColorContainer hasApplyToAll={false}
                          isSolid
                          documentColors={documentColors}
                          addDocumentColor={addDocumentColor}
                          deleteColor={deleteColor}
                          colorData={{mainColor: color}}
                          colorDataChange={textColorChanged}
                          tips={FJLocalStore._('text-color')}
                          zIndex={99999}
        />
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    loadingFonts: state.font.loadingFonts,
    fontFamily: state.watermark.watermarkFontFamily,
    color: state.watermark.watermarkTextColor,
    documentColors: state.documentColor.documentColors,
    watermarkText: state.watermark.watermarkText,
    watermarkSize: state.watermark.watermarkSize,
    watermarkOpacity: state.watermark.watermarkOpacity,
    watermarkPosition: state.watermark.watermarkPosition
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    watermarkTextChange: function (value) {
      dispatch(FJWatermarkAction.watermarkTextChangeAction(value));
    },
    fontFamilyChanged: function (value) {
      dispatch(FJWatermarkAction.watermarkFontFamilyChangeAction(value))
    },
    textColorChanged: function (type, value) {
      dispatch(FJWatermarkAction.watermarkFontColorChangeAction(type, value))
    },
    addDocumentColor: function (type, color) {
      dispatch(FJDocumentColorAction.addDocumentColorAction(type, color));
    },
    deleteColor: function (type, index) {
      dispatch(FJDocumentColorAction.deleteDocumentColorAction(type, index));
    },
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(FJWatermarkFontContainer);